module.exports = __webpack_public_path__ + "images/relate-both-cards.611cc393aaa23eb02fba.png";